/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useMemo } from "react";
import "./Nav.css";
import { Col, Container, Dropdown, Offcanvas, Row } from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  BoxArrowRight,
  PersonCircle,
  Bell,
  Trash,
} from "react-bootstrap-icons";
import { primaryColor } from "../../../Constants/Colors";
import { sidebarItems } from "./SideBarData";
import DeleteModel from "../../../Components/DeleteModel";
import { brandLogo, brandName } from "../../../Constants/content";
import { useDispatch, useSelector } from "react-redux";
import { setLogout } from "../../../redux/slices/authSlice";
import {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useDeleteNotificationMutation,
} from "../../../redux/api/NotificationApi/notificationApi";
import { Badge, ListGroup } from "react-bootstrap";
import { message } from "antd";

const { SubMenu } = Menu;
const MainNav = () => {
  const { color } = "#ffffff";
  const { user } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const { data: notificationData } = useGetNotificationsQuery(undefined, {
    pollingInterval: 15000, // Sync every 15 seconds
  });
  const [markAsRead] = useMarkAsReadMutation();
  const [deleteNotification] = useDeleteNotificationMutation();

  const notifications = notificationData?.notifications || [];
  const unreadCount = notificationData?.unreadCount || 0;
  const unreadNotifications = notifications.filter((n) => !n.isRead);

  const appCount = unreadNotifications.filter(
    (n) => n.type === "NEW_APPLICATION",
  ).length;
  const contactCount = unreadNotifications.filter(
    (n) => n.type === "NEW_CONTACT" || n.type === "NEW_NEWSLETTER",
  ).length;

  const getBadgeCount = (module) => {
    if (module === "applications") return appCount;
    if (module === "contacts") return contactCount;
    return 0;
  };

  const handleMarkAsRead = async (id) => {
    try {
      await markAsRead(id).unwrap();
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };

  const handleNotificationClick = (notification) => {
    handleMarkAsRead(notification.id);
    if (notification.type === "NEW_APPLICATION") {
      navigate(`/admin/application-detail/${notification.relatedId}`);
    } else if (notification.type === "NEW_CONTACT") {
      navigate("/admin/contacts");
    } else if (notification.type === "NEW_NEWSLETTER") {
      navigate("/admin/contacts");
    }
  };

  const handleDeleteNotification = async (e, id) => {
    e.stopPropagation();
    try {
      await deleteNotification(id).unwrap();
      message.success("Notification removed");
    } catch (error) {
      message.error("Failed to remove notification");
    }
  };

  // Filter items based on user role and dynamic permissions
  const filteredSidebarItems = useMemo(() => {
    return sidebarItems.filter((item) => {
      // Superadmin always sees everything
      if (user?.role === "superadmin") return true;

      // Check for hardcoded role restrictions first
      if (item.roles && !item.roles.includes(user?.role)) {
        return false;
      }

      // Check for dynamic permissions (module-based access)
      if (user?.permissions && user.permissions.length > 0) {
        return user.permissions.includes(item.module);
      }

      return true;
    });
  }, [user]);

  const handleClose = () => setShow(false);
  const handleNavigateAddForm = () => setShow(true);
  const handleModelClose = () => setLogoutShow(false);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(setLogout());
    navigate("/login");
  };

  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id.toString();
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(filteredSidebarItems, location.pathname);

  useEffect(() => {
    const findParentKey = (items, path) => {
      for (const item of items) {
        if (item.url === path) {
          return item.id.toString();
        }
        if (item.children) {
          const childKey = findParentKey(item.children, path);
          if (childKey) {
            return item.id.toString();
          }
        }
      }
      return null;
    };

    const parentKey = findParentKey(filteredSidebarItems, location.pathname);
    if (parentKey) {
      setOpenKeys([parentKey]);
    }
  }, [location.pathname, filteredSidebarItems]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <>
      <Container
        fluid
        className="d-flex flex-row flex-wrap-wrap justify-content-between align-items-center overflowX-hidden"
        style={{
          position: "sticky",
          top: "0",
          zIndex: 1000,
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #e9edf4",
        }}
      >
        <Row className="d-flex flex-row flex-wrap-wrap justify-content-around align-items-center p-2">
          <Col className="d-lg-none d-xl-none d-sm-flex">
            <AiOutlineMenu
              size={25}
              onClick={handleNavigateAddForm}
              className="pointer"
              color="#515b73"
            />
          </Col>
          <Col
            className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-between align-items-center"
            style={{ marginRight: "100px" }}
          >
            <img
              src={brandLogo}
              width={75}
              className="pointer"
              alt="MainLogoImage1"
              title="MainLogoImage1"
            />
          </Col>
        </Row>
        {/* mobile view */}

        <Row>
          <Col className='d-lg-none d-sm-flex flex-row flex-wrap-wrap justify-content-between" align-items-center'>
            <img
              src={brandLogo}
              width={50}
              className="p-2 pointer rounded-circle"
              alt="MainLogoImage2"
              title="MainLogoImage2"
            />
          </Col>
        </Row>

        <Row className="d-flex mt-1">
          {/* lap view */}
          <Col className="d-flex flex-row flex-wrap-wrap justify-content-center align-items-center position-relative">
            <div className="d-flex align-items-center position-relative gap-3">
              {/* Notifications Dropdown */}
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="light"
                  className="bg-transparent border-0 p-1 position-relative d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <Bell size={24} color={primaryColor} />
                  {unreadCount > 0 && (
                    <Badge
                      pill
                      bg="danger"
                      className="position-absolute translate-middle p-1 border border-light rounded-circle"
                      style={{
                        top: "8px",
                        right: "2px",
                        minWidth: "18px",
                        height: "18px",
                        fontSize: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                      }}
                    >
                      {unreadCount}
                    </Badge>
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="shadow-sm p-0 m-0 border-0"
                  style={{
                    minWidth: "350px",
                    maxWidth: "400px",
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="px-3 py-2 d-flex justify-content-between align-items-center bg-light border-bottom"
                    style={{ fontWeight: "600" }}
                  >
                    <span>Notifications</span>
                    {unreadCount > 0 && (
                      <small
                        className="text-primary pointer"
                        onClick={() => handleMarkAsRead("all")}
                      >
                        Mark all as read
                      </small>
                    )}
                  </div>

                  <ListGroup
                    variant="flush"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    {notifications.length > 0 ? (
                      notifications.map((n) => (
                        <ListGroup.Item
                          key={n.id}
                          className={`d-flex flex-column gap-1 border-bottom px-3 py-3 pointer position-relative ${!n.isRead ? "bg-light-blue" : ""}`}
                          onClick={() => handleNotificationClick(n)}
                          style={{
                            transition: "all 0.2s ease",
                            borderLeft: !n.isRead
                              ? `4px solid ${primaryColor}`
                              : "4px solid transparent",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-start gap-2">
                            <h6
                              className="mb-0 small"
                              style={{
                                color: n.isRead ? "#6d758a" : primaryColor,
                                fontWeight: n.isRead ? "500" : "700",
                              }}
                            >
                              {n.title}
                            </h6>
                            <div className="d-flex align-items-center gap-2">
                              {!n.isRead && (
                                <div
                                  className="rounded-circle"
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: primaryColor,
                                  }}
                                ></div>
                              )}
                              <Trash
                                size={14}
                                className="text-muted pointer hover-danger"
                                onClick={(e) =>
                                  handleDeleteNotification(e, n.id)
                                }
                              />
                            </div>
                          </div>
                          <p
                            className="mb-0 text-muted extra-small"
                            style={{ lineHeight: "1.4" }}
                          >
                            {n.message}
                          </p>
                          <small
                            className="text-muted mt-1"
                            style={{ fontSize: "10px" }}
                          >
                            {new Date(n.createdAt)?.toLocaleString([], {
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </small>
                        </ListGroup.Item>
                      ))
                    ) : (
                      <div className="p-4 text-center text-muted small">
                        No notifications found.
                      </div>
                    )}
                  </ListGroup>

                  <div className="p-2 border-top text-center bg-light">
                    <small
                      className="text-muted pointer"
                      onClick={() => navigate("/admin/dashboard")}
                    >
                      View All Activity
                    </small>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown align="end">
                <Dropdown.Toggle
                  id="user-dropdown"
                  variant="light"
                  className="bg-transparent border-0 p-1"
                >
                  <PersonCircle size={32} color={primaryColor} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="shadow-sm"
                  style={{ minWidth: "250px" }}
                >
                  {/* User Info Section */}
                  <div className="px-4 py-3 border-bottom">
                    <div className="d-flex align-items-center mb-2">
                      <PersonCircle size={36} className="text-primary me-2" />
                      <div>
                        <div className="fw-bold text-capitalize">
                          {user?.username}
                        </div>
                        <small className="text-muted text-uppercase small">
                          {user?.role}
                        </small>
                      </div>
                    </div>
                    <small className="text-muted d-block text-truncate">
                      {user?.email}
                    </small>
                  </div>

                  <Dropdown.Item
                    className="d-flex align-items-center py-2"
                    onClick={() => navigate("/admin/profile")}
                  >
                    <PersonCircle size={16} className="me-2" />
                    <span>My Profile</span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className="d-flex align-items-center py-2 text-danger"
                    onClick={() => setLogoutShow(true)}
                  >
                    <BoxArrowRight size={16} className="me-2" />
                    <span>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Conditionally render Offcanvas for large screens */}
      <Row className="d-none d-lg-flex">
        <Offcanvas scroll={false} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{ backgroundColor: color }} closeButton>
            <Offcanvas.Title
              className="custom-title"
              style={{
                fontSize: "16px",
                color: "#515b73",
              }}
            >
              <img
                src={brandLogo}
                width={50}
                className="rounded-circle p-2"
                alt="image"
              />
              <span className="fw-bolder" style={{ fontSize: "12px" }}>
                {brandName}
              </span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: " #FFFFFF" }}>
            <Menu
              mode="inline"
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              selectedKeys={[selectedKey]}
              style={{ height: "100%", borderRight: 0 }}
              theme="light"
            >
              {filteredSidebarItems.map((menu) =>
                menu.children && menu.children.length > 0 ? (
                  <SubMenu
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color:
                        selectedKey === menu.id.toString() ||
                        menu.children.some(
                          (child) => selectedKey === child.id.toString(),
                        )
                          ? "var(--primary-color)"
                          : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id.toString() ||
                        menu.children.some(
                          (child) => selectedKey === child.id.toString(),
                        )
                          ? "#E5D6F3"
                          : "#ffffff",
                    }}
                    title={
                      <span style={{ color: "#6d758a" }}>{menu.label}</span>
                    }
                  >
                    {menu.children.map((item) => (
                      <Menu.Item
                        key={item.id}
                        icon={item.icon}
                        style={{
                          color:
                            selectedKey === item.id.toString()
                              ? "var(--primary-color)"
                              : "#6d758a",
                          backgroundColor:
                            selectedKey === item.id.toString()
                              ? "#E5D6F3"
                              : "#ffffff",
                        }}
                      >
                        <Link
                          className="link-unstyled text-decoration-none d-flex justify-content-between align-items-center w-100"
                          onClick={handleClose}
                          to={item.url}
                        >
                          <span>{item.label}</span>
                          {getBadgeCount(item.module) > 0 && (
                            <Badge
                              pill
                              bg="danger"
                              style={{ fontSize: "10px" }}
                            >
                              {getBadgeCount(item.module)}
                            </Badge>
                          )}
                        </Link>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color:
                        selectedKey === menu.id.toString()
                          ? "var(--primary-color)"
                          : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id.toString()
                          ? "#e0dee2"
                          : "#ffffff",
                      fontWeight:
                        selectedKey === menu.id.toString() ? "600" : "",
                    }}
                  >
                    <Link
                      className="link-unstyled text-decoration-none d-flex justify-content-between align-items-center w-100"
                      onClick={handleClose}
                      to={menu.url}
                    >
                      <span>{menu.label}</span>
                      {getBadgeCount(menu.module) > 0 && (
                        <Badge pill bg="danger" style={{ fontSize: "10px" }}>
                          {getBadgeCount(menu.module)}
                        </Badge>
                      )}
                    </Link>
                  </Menu.Item>
                ),
              )}
            </Menu>
          </Offcanvas.Body>
        </Offcanvas>
      </Row>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Do You Want To Logout"
        DELETETITLE="Logout"
      />
    </>
  );
};

export default MainNav;
